"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const PersonProfilePicture_1 = __importDefault(require("../../common/PersonProfilePicture"));
const ContactTracingApi_1 = __importDefault(require("../../../api/ContactTracingApi"));
const moment_1 = __importDefault(require("moment"));
const ClassPersonComponent = (props) => {
    const [isBusy, setIsBusy] = (0, react_1.useState)(false);
    const addContact = () => {
        setIsBusy(true);
        let contactResponse = {
            case_guid: props.caseData.case_guid,
            title: "",
            contact_date: (0, moment_1.default)().format("YYYY-MM-DD"),
            contact_guid: "",
            contact_number: "",
            department: "",
            display_name: `${props.member.firstName} ${props.member.lastName}`,
            email_address: "",
            ext_guid: "",
            is_external: false,
            mit_id: props.member.mitId,
            medical_status_id: 0,
            medical_status_name: "",
            medical_hold_guid: "",
        };
        ContactTracingApi_1.default
            .postContact(props.caseData.case_guid, contactResponse)
            .then((response) => {
            if (response.error) {
            }
            else {
                if (response.items) {
                    props.onContact();
                }
            }
        })
            .finally(() => {
            setIsBusy(false);
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row no-gutters d-flex justify-content-between" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `meh ${props.member.vaccinationStatus}` }, { children: [(0, jsx_runtime_1.jsx)(PersonProfilePicture_1.default, { id: props.member.mitId }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "patientname with-title" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", Object.assign({ className: "member-name" }, { children: [props.member.firstName, " ", props.member.lastName] })), (0, jsx_runtime_1.jsxs)("p", { children: [props.member.email && ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "mail-link", onClick: () => window.open(`mailto:${props.member.email}`) }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-envelope" }), " Email"] }))), " ", props.member.phoneNumber && ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "mail-link", onClick: () => window.open(`tel:${props.member.phoneNumber}`) }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "far fa-phone" }), " ", props.member.phoneNumber ? props.member.phoneNumber : "N/A"] })))] })] }) }))] })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "no-border-btn" }, { children: !props.member.isCaseContact ? ((0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "plus", isBusy: isBusy, state: isBusy ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, text: "Add as contact", type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Secondary, onClick: () => addContact() })) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "d-flex justify-content-center p-3 h-100" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: "Contact" }) }))) }))] })));
};
const ClassPerson = ClassPersonComponent;
exports.default = ClassPerson;
